var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating",class:'rating--'+_vm.theme+' '+(_vm.animated ? 'rating--animated':'')},_vm._l((_vm.total),function(i){return _c('div',{key:i,staticClass:"star",class:{'star--filled': (i <= _vm.count)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }